module.exports = __webpack_public_path__ + "img/max10.c5326d96.jpg";